
















































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { formRules } from '@/common/util/validator';
import { Area } from '@/http';

interface MapAddress {
    value: string;
    text: string;
    fullName: string;
    parentCode: string;
    parentName: string;
    type: string;
}

// 表示所选
export interface SelectAddress {
    province?: MapAddress;
    city?: MapAddress;
    area?: MapAddress;
}

@Component({
    components: {},
})
export default class AddressSelect extends Vue {
    @Prop({
        default: false,
    })
    public reset: boolean;
    @Watch('reset')
    public async reloadSelect(val: boolean) {
        if (val) {
            console.log('val', val);

            await this.init();
            this.$emit('updateReset');
        }
    }
    public selectRest = null;
    @Prop({
        default: '',
    })
    public disabledStatus: any;
    @Prop()
    public searchTerm: boolean;
    public formRules = formRules;
    public $refs: {
        form: HTMLFormElement;
    };
    public form = {
        selectProvince: '',
        selectCity: '',
        selectArea: '',
    };
    public provinceArray: MapAddress[] = [];
    public cityOptions: MapAddress[] = [];
    public areaOptions: MapAddress[] = [];
    public selectProvince = '';
    public selectCity = '';
    public selectArea = '';

    @Prop({
        default: true,
    })
    public isChangeMileage: boolean;

    @Prop()
    public value: SelectAddress;

    @Prop({
        default: false,
    })
    public notUseArea: boolean;

    @Prop({
        default: false,
    })
    public isplaceholder: boolean;

    public isplaceholderStatus = null;

    @Watch('isplaceholder')
    public async getPlaceholder(state: boolean) {}

    public selfValue: MapAddress[] = [];

    @Watch('value')
    public async reloadValue(v) {
        await this.init();
    }

    setValue(data) {
        this.value = data;
        this.init();
    }

    public clear() {
        this.form = {
            selectProvince: '',
            selectCity: '',
            selectArea: '',
        };
        this.$refs['form'].resetFields();
    }

    public created() {
        this.selectRest = this.reset;
        this.isplaceholderStatus = this.isplaceholder;
        if (this.selectRest) {
            console.log('111')
            this.init();
        }
    }

    // 初始化
    public async init() {
        await this.getProvince();
        if (this.value) {
            let names = '';
            if (this.value.province.value) {
                console.log('province.value', this.value.province.value);
                this.form.selectProvince = this.value.province.value;
                let name = '';
                this.provinceArray.forEach((e) => {
                    if (this.form.selectProvince == e.value) {
                        name = e.text;
                    }
                });
                names = names + name;
                this.$emit('getName', names);
                if (this.isChangeMileage) {
                    this.$emit('provincePrompts', `${this.form.selectProvince}`, `${name}`);
                }
            } else {
                this.form.selectProvince = this.value.province.value;
            }
            if (this.value.city.value) {
                console.log('city.value', this.value.city.value);

                await this.getCityList(this.value.province.value);
                this.form.selectCity = this.value.city.value;
                let name = '';
                this.cityOptions.forEach((e) => {
                    if (this.form.selectCity == e.value) {
                        name = e.text;
                    }
                });
                const named = names;
                names = names + name;
                this.$emit('getName', names, named, name);
                if (this.isChangeMileage) {
                    this.$emit('cityPrompts', `${this.form.selectCity}`, `${name}`);
                }
            } else {
                this.form.selectCity = this.value.city.value;
            }
            if (this.value.area.value) {
                await this.getCountyList(this.value.city.value);
                this.form.selectArea = this.value.area.value;
                let name = '';
                this.areaOptions.forEach((e) => {
                    if (this.form.selectArea == e.value) {
                        name = e.text;
                    }
                });
                names = names + name;
                this.$emit('getName', names);
                if (this.isChangeMileage) {
                    this.$emit('areaPrompts', `${this.form.selectArea}`, `${name}`);
                }
            } else {
                // this.$refs['form'].resetFields();
                if (this.value.city.value) {
                    console.log('vvvvs', this.value.city.value);
                    await this.getCountyList(this.value.city.value);
                } else {
                    this.$refs['form'].resetFields();
                }
                this.form.selectArea = this.value.area.value;
            }
        }
    }

    async getProvince() {
        let area = await Area.area();
        this.provinceArray = area.data;
    }

    async getCityList(code) {
        let city = await Area.city(code);
        this.cityOptions = city.data;
    }

    async getCountyList(code) {
        let County = await Area.county(code);
        this.areaOptions = County.data;
    }

    public getProvinceAddress(id: string): MapAddress {
        for (let item of this.provinceArray) {
            if (id === item.value) {
                return item;
            }
        }
    }

    public getCityAddress(id: string): MapAddress {
        for (let item of this.cityOptions) {
            if (id === item.value) {
                return item;
            }
        }
    }

    public getAreaAddress(id: string): MapAddress {
        for (let item of this.areaOptions) {
            if (id === item.value) {
                return item;
            }
        }
    }

    // 选择省
    public provinceChange(selectValue) {
        this.cityOptions = [];
        this.areaOptions = [];
        this.form.selectCity = '';
        this.form.selectArea = '';
        if (this.form.selectProvince != '') {
            this.getCityList(this.form.selectProvince);
        }
        let name = '';
        this.provinceArray.forEach((e) => {
            if (this.form.selectProvince == e.value) {
                name = e.text;
            }
        });
        this.$emit('provincePrompts', `${this.form.selectProvince}`, `${name}`);
    }

    // 选市
    public cityChange(selectValue) {
        if (this.form.selectCity != '') {
            this.getCountyList(this.form.selectCity);
        }
        this.areaOptions = [];
        this.form.selectArea = '';
        let name = '';
        this.cityOptions.forEach((e) => {
            if (this.form.selectCity == e.value) {
                name = e.text;
            }
        });
        this.$emit('cityPrompts', `${this.form.selectCity}`, `${name}`);
    }

    // 选区
    public areaChange(selectValue) {
        let name = '';
        this.areaOptions.forEach((e) => {
            if (this.form.selectArea == e.value) {
                name = e.text;
            }
        });
        this.$emit('areaPrompts', `${this.form.selectArea}`, `${name}`);
    }

    /* 触发地址组件的校验 */
    public validateForm() {
        let flag = false;
        this.$refs.form.validate((valid) => {
            flag = valid;
        });
        return flag;
    }
}
